module.exports = __webpack_public_path__ + "img/spfl.5b53a38a.png";